(function () {
    'use strict';

    var app = angular.module('inoApp');
    app.directive('widgetDataTable', ['$timeout', 'config', 'widgetControlConfig', function ($timeout, config, widgetControlConfig) {
        var directive = {
            restrict: 'E',
            link: link,
            replace: true,
            transclude: true,
            controller: 'DataTableController as vm',
            templateUrl: config.clientAppSrcPath + 'app/Core/directives/widgetDataTable/widgetDataTable.html',
            scope: {
                widgetDataItems: '=',
                widgetTitle: '@',
                widgetIconClass: '@',
                widgetConfig: '=',
                enableCustomFiltering: '='
            }
        };
        return directive;

        function link(scope, element, attrs, controller) {
            controller.rootElement = element;
            controller.widgetDataTableScope = scope;

            // init jarvis widget after render
            $timeout(function () {
                controller.createDataTable(scope);
                $(element).on('dataTables.updateLanguage', controller.updateLanguage);
            });
        }
    }
    ]).directive('widgetDataRow', ['$timeout', function ($timeout) {
        return {
            replace: false,
            require: '^widgetDataTable',
            restrict: 'EA',
            link: link,
            scope: {
                rowIndex: '=widgetDataRow'
            }
        };
        function link(scope, iElement, iAttrs, controller) {
            scope.$on("$destroy", function () {
                controller.removeRowAt(scope.rowIndex)
            });

            $timeout(function () {
                var trElement = angular.element(iElement);
                controller.addRow(trElement);
            });
        }
    }
    ]).directive('widgetDataTableFiltering', [function () {
        return {
            replace: false,
            require: '^widgetDataTable',
            transclude: true,
            restrict: 'E',
            template: '<div ng-transclude></div>',
            link: {
                post: postlink
            },
        };
        function postlink(scope, iElement, iAttrs, controller, transcludeFn) {
            controller.customFilteringTransclude = transcludeFn;
            angular.element(iElement[0]).remove();
        }
    }]);


    var controllerId = "DataTableController";
    app.controller(controllerId, ['$scope','$timeout', DataTableController]);
    function DataTableController($scope, $timeout) {
        var vm = this;
        // Variables set by setup
        vm.rootElement = null;
        vm.widgetDataTableScope = null;
        vm.customFilteringTransclude = null;
        vm.tableData = null;
        vm.createDataTable = createDataTable;
        vm.updateLanguage = updateLanguage;
        vm.removeRowAt = removeRowAt;
        vm.addRow = addRow;

        function removeRowAt(index) {
            vm.tableData.rows().remove(index).draw();
        }

        function addRow(trElement) {
            vm.tableData.row.add(trElement).draw();
        }

        function createDataTable() {
            if (vm.tableData != null) {
                vm.tableData.destroy(); //important! you have to destroy first or you'll get an alert-error.
                vm.tableData = null;
            }

            //breakpoint definitions
            var breakpointDefinition = {
                tablet: 1024,
                phone: 480
            };
            var responsiveHelper_dt_basic = null;

            var table = $(vm.rootElement).find('.table-datatable');
            table.dataTable({
                "preDrawCallback": function () {
                    // Initialize the responsive datatables helper once.
                    if (!responsiveHelper_dt_basic) {
                        responsiveHelper_dt_basic = new ResponsiveDatatablesHelper(table, breakpointDefinition);
                    }
                },
                "rowCallback": function (nRow) {
                    responsiveHelper_dt_basic.createExpandIcon(nRow);
                },
                "drawCallback": function (oSettings) {
                    responsiveHelper_dt_basic.respond();
                },
                "searching": vm.widgetDataTableScope.enableCustomFiltering === true ? false : true,
                "language": appConfig.dataTables.currentLang,
                "autoWidth": false
            });

            vm.tableData = table.DataTable();

            // Create a clone of originally created element and add to data table if translcude function was set
            if (vm.customFilteringTransclude)
                $timeout(function () {
                    vm.customFilteringTransclude(function (clone, scope) {
                        $(vm.rootElement).find('.dt-toolbar > div').first().append(clone);
                    });
                });
        }

        function updateLanguage() {
            // re-create table since there is no dynamic language change method
            vm.createDataTable();
        }
    }
})();